import api from '@pray/shared/utils/api';

import type { ContentTag } from './getContentTags';

export interface RemoveContentTagResponse {
  data: ContentTag[];
}

export interface RemoveContentTagParams {
  artistId: string;
  contentId: string;
  tagId: string;
}

/**
 * Remove a tag from a content item
 */
export async function removeContentTag({
  artistId,
  contentId,
  tagId,
}: RemoveContentTagParams): Promise<RemoveContentTagResponse> {
  const url = `/web/studio/artists/${artistId}/content/${contentId}/tags/${tagId}`;
  const response = await api.executeDeleteRequest<RemoveContentTagResponse>(url);
  return response.data;
}
